// src/shared/utils/extplatBrandConfig.ts

import { FACEBOOK_APP_IDS, YOUTUBE_CLIENT_IDS } from '@/lib/constants/extplat';
import { ResellerBrand } from '@/shared/utils/resellerBrand';
import type { CustomercfgResellerData } from '@/lib/types/Customer';

/**
 * Brand-aware configuration for external platform integrations.
 *
 * Uses the account-based brand rule (`ResellerBrand.isReseller`, matching legacy
 * behavior). This is critical because the Facebook/YouTube app IDs determine which
 * app secret the backend uses when calling external APIs — using the wrong app ID
 * causes auth failures.
 */
export class ExtPlatConfig {
  /** Check if a customer account is a reseller (themediacdn brand). */
  static isReseller(reseller: CustomercfgResellerData | undefined | null): boolean {
    return ResellerBrand.isReseller(reseller);
  }

  static getFacebookAppId(reseller: CustomercfgResellerData | undefined | null): string {
    return this.isReseller(reseller) ? FACEBOOK_APP_IDS.themediacdn : FACEBOOK_APP_IDS.streamhoster;
  }

  static getYouTubeClientId(reseller: CustomercfgResellerData | undefined | null): string {
    return this.isReseller(reseller) ? YOUTUBE_CLIENT_IDS.themediacdn : YOUTUBE_CLIENT_IDS.streamhoster;
  }
}
